import React from 'react';

export function ApartmentMonthIcon({ className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33073 2.5H16.6641V16.25H18.3307V17.5H1.66406V16.25H3.33073V2.5ZM6.66406 5.83333H9.16406V7.08333H6.66406V5.83333ZM10.8307 5.83333H13.3307V7.08333H10.8307V5.83333ZM6.66406 9.16667H9.16406V10.4167H6.66406V9.16667ZM10.8307 9.16667H13.3307V10.4167H10.8307V9.16667ZM6.66406 12.5H9.16406V13.75H6.66406V12.5ZM10.8307 12.5H13.3307V13.75H10.8307V12.5Z"
        fill="#92A0AE"
      />
    </svg>
  );
}
